export type PlanCardFeatureType = {
    label: string;
    highlighted?: boolean;
    tooltip?: string;
};

export type PlanCardType = {
    icon: string;
    description: string;
    features: PlanCardFeatureType[];
};

type PlanCardsType = Record<string, PlanCardType>;

export const planCards: PlanCardsType = {
    launch: {
        icon: 'account-emoji-outline',
        description: 'plan_description.launch',
        features: [
            { label: 'plan_features.user', highlighted: true },
            { label: 'plan_features.email_support', highlighted: true },
            { label: 'plan_features.standard_analytics_and_reports' },
            { label: 'plan_features.scheduled_posts_limit' },
            { label: 'plan_features.best_time_to_post_suggestion' },
            { label: 'plan_features.ai_caption_content_inspiration' },
            { label: 'plan_features.1_year_data_retention_and_history' }
        ]
    },
    scale: {
        icon: 'rocket-outline',
        description: 'plan_description.scale',
        features: [
            {
                label: 'plan_features.users',
                highlighted: true,
                tooltip: 'plan_features.users_tooltip'
            },
            { label: 'plan_features.email_chat_support', highlighted: true },
            {
                label: 'plan_features.manage_groups_1',
                tooltip: 'plan_features.manage_groups_1_tooltip'
            },
            { label: 'plan_features.campaigns_tracking_and_reporting' },
            { label: 'plan_features.promoted_posts_analytics' },
            { label: 'plan_features.external_collaboration' },
            { label: 'plan_features.hashtags_mentions_tracking' },
            { label: 'plan_features.competitors_benchmarking_and_unlimited_report' },
            { label: 'plan_features.dm' },
            { label: 'plan_features.2_years_data_retention_and_history' }
        ]
    },
    excel: {
        icon: 'gem-outline',
        description: 'plan_description.excel',
        features: [
            {
                label: 'plan_features.users',
                highlighted: true,
                tooltip: 'plan_features.users_tooltip'
            },
            { label: 'plan_features.email_chat_support_priority', highlighted: true },
            {
                label: 'plan_features.unlimited_groups',
                tooltip: 'plan_features.manage_groups_5_tooltip'
            },
            { label: 'plan_features.customized_reports' },
            { label: 'plan_features.white_labelled_reports' },
            { label: 'plan_features.competitors_benchmarking_unlimited' },
            { label: 'plan_features.api_access' },
            { label: 'plan_features.onboarding' },
            { label: 'plan_features.dedicated_csm_and_continuous_training' },
            { label: 'plan_features.unlimited_data_retention' }
        ]
    },
    agency: {
        icon: 'briefcase-outline',
        description: 'plan_description.agency',
        features: [
            {
                label: 'plan_features.unlimited_users',
                highlighted: true
            },
            { label: 'plan_features.unlimited_social_profiles', highlighted: true },
            { label: 'plan_features.flexible_social_profiles' },
            { label: 'plan_features.scalability' },
            { label: 'plan_features.agency_oriented' }
        ]
    }
} as const;
